import { RootState } from "../store"

export const selectBooksToc = (state: RootState) => state.books.booksToc

export const selectBooksTocLength = (state: RootState) =>
  state.books.booksToc.length
